const section = document.querySelector('.gallery-section-one');
if (section) {
    const tabs    = section.querySelectorAll('.gallery-section-one__tab');
    const panels  = section.querySelectorAll('.gallery-section-one__panel');
    const tabsEl  = section.querySelector('.gallery-section-one__tabs');
    const wrapper = section.querySelector('.gallery-section-one__tabs-wrapper');

    // === Indicator ===
    const indicator = section.querySelector('.gallery-section-one__tabs-indicator');

    function updateIndicator(activeTab) {
        if (!indicator || !wrapper || window.innerWidth >= 768) return;
        const tabRect     = activeTab.getBoundingClientRect();
        const wrapperRect = wrapper.getBoundingClientRect();
        indicator.style.left  = (tabRect.left - wrapperRect.left) + 'px';
        indicator.style.width = tabRect.width + 'px';
    }

    // === Masks ===
    function updateMasks() {
        if (!tabsEl || !wrapper) return;
        const { scrollLeft, scrollWidth, clientWidth } = tabsEl;
        wrapper.classList.toggle('gallery-section-one__tabs-wrapper--mask-left', scrollLeft > 1);
        wrapper.classList.toggle('gallery-section-one__tabs-wrapper--mask-right', scrollLeft + clientWidth < scrollWidth - 1);
    }

    if (tabsEl) {
        tabsEl.addEventListener('scroll', () => {
            updateMasks();
            const activeTab = section.querySelector('.gallery-section-one__tab--active');
            if (activeTab) {
                if (indicator) indicator.style.transition = 'none';
                updateIndicator(activeTab);
            }
        }, { passive: true });
        updateMasks();
    }

    const initialActive = section.querySelector('.gallery-section-one__tab--active');
    if (initialActive) updateIndicator(initialActive);

    // === Animate items ===
    function animateItems(panel) {
        const items = panel.querySelectorAll('.gallery-section-one__item');
        items.forEach(item => {
            item.classList.remove('gallery-section-one__item--visible');
            item.style.transitionDelay = '';
        });

        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (!entry.isIntersecting) return;
                const item  = entry.target;
                const index = parseInt(item.dataset.index, 10);
                item.style.transitionDelay = `${index * 80}ms`;
                item.classList.add('gallery-section-one__item--visible');
                observer.unobserve(item);
            });
        }, { threshold: 0.1 });

        items.forEach((item, i) => {
            item.dataset.index = i;
            observer.observe(item);
        });
    }

    const activePanel = section.querySelector('.gallery-section-one__panel--active');
    if (activePanel) animateItems(activePanel);

    // === Tabs ===
    tabs.forEach(tab => {
        tab.addEventListener('click', () => {
            const index = tab.dataset.tab;

            tabs.forEach(t => {
                t.classList.remove('gallery-section-one__tab--active');
                t.setAttribute('aria-selected', 'false');
            });
            panels.forEach(p => p.classList.remove('gallery-section-one__panel--active'));

            tab.classList.add('gallery-section-one__tab--active');
            tab.setAttribute('aria-selected', 'true');

            const newPanel = section.querySelector(`.gallery-section-one__panel[data-panel="${index}"]`);
            if (newPanel) {
                newPanel.classList.add('gallery-section-one__panel--active');
                animateItems(newPanel);
            }
            if (indicator) indicator.style.transition = 'left 0.2s ease, width 0.2s ease';
            updateIndicator(tab);
        });
    });

    // === Lightbox ===
    const lightbox     = section.querySelector('.gallery-section-one__lightbox');
    const lbBackdrop   = section.querySelector('.gallery-section-one__lightbox-backdrop');
    const lbImg        = section.querySelector('.gallery-section-one__lightbox-img');
    const lbThumbs     = section.querySelector('.gallery-section-one__lightbox-thumbs');
    const lbPrev       = section.querySelector('.gallery-section-one__lightbox-prev');
    const lbNext       = section.querySelector('.gallery-section-one__lightbox-next');
    const lbClose      = section.querySelector('.gallery-section-one__lightbox-close');
    const lbCounter    = section.querySelector('.gallery-section-one__lightbox-counter');

    let lbImages  = [];
    let lbCurrent = 0;

    function getActiveImages() {
        const panel = section.querySelector('.gallery-section-one__panel--active');
        if (!panel) return [];
        return Array.from(panel.querySelectorAll('.gallery-section-one__item img'));
    }

    function buildThumbs() {
        lbThumbs.innerHTML = '';
        lbImages.forEach((img, i) => {
            const thumb = document.createElement('div');
            thumb.className = 'gallery-section-one__lightbox-thumb';
            if (i === lbCurrent) thumb.classList.add('gallery-section-one__lightbox-thumb--active');
            const t = document.createElement('img');
            t.src = img.src;
            t.alt = img.alt;
            thumb.appendChild(t);
            thumb.addEventListener('click', () => goTo(i));
            lbThumbs.appendChild(thumb);
        });
    }

    function centerThumb(index) {
        const thumbEls = lbThumbs.querySelectorAll('.gallery-section-one__lightbox-thumb');
        if (!thumbEls[index]) return;
        thumbEls[index].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
    }

    function updateCounter() {
        if (lbCounter) lbCounter.textContent = `${lbCurrent + 1} / ${lbImages.length}`;
    }

    function goTo(index) {
        lbCurrent = (index + lbImages.length) % lbImages.length;
        lbImg.src = lbImages[lbCurrent].src;
        lbImg.alt = lbImages[lbCurrent].alt;

        lbThumbs.querySelectorAll('.gallery-section-one__lightbox-thumb').forEach((t, i) => {
            t.classList.toggle('gallery-section-one__lightbox-thumb--active', i === lbCurrent);
        });
        centerThumb(lbCurrent);
        updateCounter();
    }

    function openLightbox(index) {
        lbImages  = getActiveImages();
        lbCurrent = index;
        buildThumbs();
        lbImg.src = lbImages[lbCurrent].src;
        lbImg.alt = lbImages[lbCurrent].alt;
        lightbox.setAttribute('aria-hidden', 'false');
        lightbox.classList.add('gallery-section-one__lightbox--open');
        document.body.style.overflow = 'hidden';
        centerThumb(lbCurrent);
        updateCounter();
    }

    function closeLightbox() {
        lightbox.classList.remove('gallery-section-one__lightbox--open');
        lightbox.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
    }

    section.querySelectorAll('.gallery-section-one__item').forEach(item => {
        item.style.cursor = 'pointer';
        item.addEventListener('click', () => {
            const panel  = section.querySelector('.gallery-section-one__panel--active');
            const items  = Array.from(panel.querySelectorAll('.gallery-section-one__item'));
            const index  = items.indexOf(item);
            openLightbox(index);
        });
    });

    lbPrev.addEventListener('click', () => goTo(lbCurrent - 1));
    lbNext.addEventListener('click', () => goTo(lbCurrent + 1));
    section.querySelector('.gallery-section-one__lightbox-prev-mobile')?.addEventListener('click', () => goTo(lbCurrent - 1));
    section.querySelector('.gallery-section-one__lightbox-next-mobile')?.addEventListener('click', () => goTo(lbCurrent + 1));
    lbClose.addEventListener('click', closeLightbox);
    lightbox.addEventListener('click', closeLightbox);
    section.querySelector('.gallery-section-one__lightbox-content').addEventListener('click', e => e.stopPropagation());

    // Swipe mobile
    let touchStartX = 0;
    const lbImgContainer = section.querySelector('.gallery-section-one__lightbox-img-container');
    lbImgContainer.addEventListener('touchstart', (e) => {
        touchStartX = e.touches[0].clientX;
    }, { passive: true });
    lbImgContainer.addEventListener('touchend', (e) => {
        const diff = touchStartX - e.changedTouches[0].clientX;
        if (Math.abs(diff) > 40) goTo(diff > 0 ? lbCurrent + 1 : lbCurrent - 1);
    }, { passive: true });

    document.addEventListener('keydown', (e) => {
        if (!lightbox.classList.contains('gallery-section-one__lightbox--open')) return;
        if (e.key === 'ArrowLeft')  goTo(lbCurrent - 1);
        if (e.key === 'ArrowRight') goTo(lbCurrent + 1);
        if (e.key === 'Escape')     closeLightbox();
    });
}
